import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { ModalHeader } from '../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalCloseButton } from '../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalBody } from '../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalFooter } from '../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../../../CommonComponents/OPL/Modal/Modal';
import { DeleteGoalModal } from '../DeleteGoalModal/DeleteGoalModal';
import { GoalType } from '../../api/useGoalsQuery';
import { hasAccessToEditProfileSelector } from '../../../../CommonSelectors/CommonAreaSelector';

interface Props {
  id?: string | null;
  name: string;
  type: GoalType;
  formId: string;
  clientId: string;
  isLoading: boolean;
  onClose(): void;
  children: React.ReactNode;
}

export const UpsertGoalModal = ({
  id,
  name,
  type,
  formId,
  clientId,
  isLoading,
  onClose,
  children,
}: Props) => {
  const canEdit = useSelector(hasAccessToEditProfileSelector);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  return (
    <>
      <Modal
        isOpen
        isHidden={isDeleteModalOpen}
        onRequestClose={onClose}
        shouldCloseOnOverlayClick={false}
        aria={{ labelledby: 'upsert-goal-modal--header' }}
      >
        <ModalHeader as="h2" id="upsert-goal-modal--header">
          {id ? (canEdit ? 'Edit' : 'View') : 'Add'}{' '}
          {type === GoalType.LargePurchase
            ? 'Large Purchase'
            : type === GoalType.HomePurchase
            ? 'Home Purchase'
            : name}{' '}
          Goal
        </ModalHeader>
        <ModalCloseButton onClick={onClose} />

        <ModalBody>{children}</ModalBody>

        <ModalFooter>
          {canEdit && id && (
            <Button mr="auto" variant="errorSecondary" onClick={() => setIsDeleteModalOpen(true)}>
              Remove Goal from Plan
            </Button>
          )}

          <Button variant="subtleInactive" onClick={onClose}>
            {canEdit ? 'Cancel' : 'Close'}
          </Button>

          {canEdit && (
            <Button type="submit" form={formId} ml="8" isLoading={isLoading}>
              {id ? 'Save' : 'Add Goal'}
            </Button>
          )}
        </ModalFooter>
      </Modal>

      {isDeleteModalOpen && id && (
        <DeleteGoalModal
          clientId={clientId}
          goalId={id}
          onClose={() => setIsDeleteModalOpen(false)}
          onSuccess={onClose}
        />
      )}
    </>
  );
};
